import { usePatient } from "Components/usePatientContext"
import api from "lib/api_clinica"
import { useCallback, useState } from "react"
import { toast } from "react-toastify"

export default function useConvenios() {

    const [ data, setData       ] = useState([])
    const [ loading, setLoading ] = useState([])

    const { 
        setPatient, 
        setRedirect 
    } = usePatient()
    
    const getConvenios = useCallback( async () => {
        
        try {
            
            setLoading(true)

            const response = await api.convenios.get()
            
            setData(response)

        } catch (error) {
            console.log(error)
            toast.error('Não conseguir listar os convênios nesse momento')    
        } finally {
            
            setLoading(false)
        }
        // eslint-disable-next-line
    }, [setData, setLoading])


    const selectItem = item => {
        
        setPatient( prevState => {
            
            return {
                ...prevState, 
                idConvenio: item.idConvenio,
                descricaoConvenio: item.descricaoConvenio,
                idPlano: process.env.REACT_APP_ID_PLANO,
            }
        })
        
        setRedirect('/especialidade')
          
    }

    const handleData = useCallback( (items) => {
        setData( items )
    }, [setData])

    return { 
        data, 
        setData, 
        getConvenios, 
        selectItem,
        handleData,
        loading, 
    }
}